var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBxUnderline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 18,
    viewBox: "0 0 17 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.54102 13.2487H13.4577V14.6654H3.54102V13.2487ZM4.24935 3.33203V7.58203C4.24935 9.92591 6.15547 11.832 8.49935 11.832C10.8432 11.832 12.7493 9.92591 12.7493 7.58203V3.33203H11.3327V7.58203C11.3327 9.14462 10.0619 10.4154 8.49935 10.4154C6.93677 10.4154 5.66602 9.14462 5.66602 7.58203V3.33203H4.24935Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBxUnderline);
export default __webpack_public_path__ + "static/media/bx-underline.b887a0ed790782aa03b7c22cbda73863.svg";
export { ForwardRef as ReactComponent };